import React from 'react';
import styled from 'styled-components';

const Heading = styled.h3`
    background-image: linear-gradient(0deg, #990820 0%, #ba0020 100%) !important;
    color: #fff;
    padding: 20px;
    border-radius: 7px;
`;


const ScheduleCardYear = (props) => {
    return(
        <Heading>{props.Year} &ensp;{props.title}</Heading>
    );
}

export default ScheduleCardYear;